import { render, staticRenderFns } from "./LoaderContainer.vue?vue&type=template&id=4604c130&scoped=true&functional=true&"
import script from "./LoaderContainer.vue?vue&type=script&lang=js&"
export * from "./LoaderContainer.vue?vue&type=script&lang=js&"
import style0 from "./LoaderContainer.vue?vue&type=style&index=0&id=4604c130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4604c130",
  null
  
)

export default component.exports